import { LayoutGamesMainWebView } from "@/components/webview/games/layout/LayoutGamesMainWebView";
import GamesBannerWebView from "@/components/webview/games/core/GamesBannerWebView";
import { Button } from "@/v2-components/ui/button";
import { Button2 } from "@/components/webview/games/typograpy/typograpy-webview";
import { useTrans } from "@/utils/useTrans";
import { GamesWrapLazyContentsWebView } from "@/components/webview/games/GamesWrapLazyContentsWebView";
import React from "react";
import AudioToHapticsLazySectionsWebView from "@/components/webview/games/main/AudioToHapticsLazySectionsWebView";
import { openBrowserWebView } from "@/components/webview/utils/webViewBridge";

export const AudioToHapticsWebView = () => {
  const { t } = useTrans(["games"]);

  return (
    <LayoutGamesMainWebView
      bannerImg={"/images/games/banners/audio-to-haptic-mobile@3x.jpg"}
      bannerContents={
        <>
          <GamesBannerWebView.Title
            text={t(`Feel the Sound Not Just Hear It`)}
          />
          <GamesBannerWebView.Description
            text={t(
              `bHaptics Audio-to-Haptic transforms in-game sounds, music, and movies into dynamic haptic feedback for total immersion.`,
            )}
          />
          <div className="mt-6 flex w-full flex-col gap-2 laptop:mt-8 laptop:flex-row">
            <Button
              size="sm"
              variant="darkgray-outline"
              shape="pill"
              className="bg-transparent px-6 laptop:text-blue-60 laptop:outline-blue-60 laptop:hover:bg-blue-60 laptop:hover:text-white"
              onClick={() => {
                openBrowserWebView({
                  url: "support/help/?categorySlug=haptic-experiences-audio-to-haptics-wireless-ath-wireless-ath-settings",
                });
              }}
            >
              <Button2>{t("Using a Windows PC")}</Button2>
            </Button>
            <Button
              size="sm"
              variant="darkgray-fill"
              shape="pill"
              className="bg-black px-6 text-white focus-visible:outline-none"
              onClick={() => {
                openBrowserWebView({
                  url: "support/help/?categorySlug=haptic-experiences-audio-to-haptics-wired-ath-getting-started-with-wired-ath",
                });
              }}
            >
              <Button2>{t("Using other platforms")}</Button2>
            </Button>
          </div>
        </>
      }
    >
      {/* lazy 하게 게임컴포넌트를 가져옵니다 */}
      <GamesWrapLazyContentsWebView
        contents={<AudioToHapticsLazySectionsWebView />}
      />
    </LayoutGamesMainWebView>
  );
};
